import React from 'react';
import cl from './Vrasrabotke.module.css';
import gif from './img/1.gif';

const Vrasrabotke = () => {
    return (
        <div className={cl.pageWrapper}>
            <div className={cl.contentContainer}>
                <img src={gif} alt="В разработке" className={cl.gifImage} />
                <h1 className={cl.title}>Страница в разработке</h1>
                <p className={cl.subtitle}>Загляни позже!</p>
            </div>
        </div>
    );
};

export default Vrasrabotke;
